var map = {
	"./Auth/Login": 7069,
	"./Auth/Login.jsx": 7069,
	"./Dashboard": 1588,
	"./Dashboard.jsx": 1588,
	"./Error": 8665,
	"./Error.jsx": 8665,
	"./Fee/AdvanceAlert": 6042,
	"./Fee/AdvanceAlert.jsx": 6042,
	"./Fee/Alert": 6597,
	"./Fee/Alert.jsx": 6597,
	"./Fee/GroupAlert": 4441,
	"./Fee/GroupAlert.jsx": 4441,
	"./Fee/Import": 1726,
	"./Fee/Import.jsx": 1726,
	"./Fee/Index": 4399,
	"./Fee/Index.jsx": 4399,
	"./Group/Create": 743,
	"./Group/Create.jsx": 743,
	"./Group/Edit": 2595,
	"./Group/Edit.jsx": 2595,
	"./Group/Index": 8673,
	"./Group/Index.jsx": 8673,
	"./Home": 7250,
	"./Home.jsx": 7250,
	"./Notification/Index": 5680,
	"./Notification/Index.jsx": 5680,
	"./Password/Index": 2751,
	"./Password/Index.jsx": 2751,
	"./Profile/Edit": 7128,
	"./Profile/Edit.jsx": 7128,
	"./Settings/Sms/Create": 2379,
	"./Settings/Sms/Create.jsx": 2379,
	"./Sms/Dynamic": 1692,
	"./Sms/Dynamic.jsx": 1692,
	"./Sms/Quick": 5496,
	"./Sms/Quick.jsx": 5496,
	"./Student/Create": 1091,
	"./Student/Create.jsx": 1091,
	"./Student/Edit": 2242,
	"./Student/Edit.jsx": 2242,
	"./Student/Import": 2421,
	"./Student/Import.jsx": 2421,
	"./Student/Index": 358,
	"./Student/Index.jsx": 358,
	"./User/Create": 118,
	"./User/Create.jsx": 118,
	"./User/Edit": 7688,
	"./User/Edit.jsx": 7688,
	"./User/Index": 4562,
	"./User/Index.jsx": 4562
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3218;